import { useState, useEffect, useContext } from "react";
import { TextField, Button, Paper, Typography, Box } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { SidebarContext } from "core/contexts/sidebar/sidebar";
import { SidebarSearchContainer } from "./sidebar.styled";
import { CustomInputBox } from "core/components/global/input/inputBox/inputBox";
import { useAppTheme } from "core/contexts/theme/theme";

export const SidebarSearch = () => {
  const [stateToFind, setStateToFind] = useState("");
  const [results, setResults] = useState<any[]>([]);
  const [notFound, setNotFound] = useState(false);

  const { setExpandedNodes, modelData } = useContext(SidebarContext);

  /**
   *  Recursively search through the 'sidebarData' data
   */
  const findStateRecursive = (data, targetState, parentPath = []) => {
    let results: string[] = [];

    // Check each item in the array
    for (const item of data) {
      // Create current path including this item
      const currentPath: any = [...parentPath, item.state];

      // If this item has the target state, add it to results with its path
      if (
        item.state &&
        item.sidebarProps.displayText
          .toLowerCase()
          .includes(targetState.toLowerCase())
      ) {
        results.push({
          ...item,
          parentPath: currentPath.slice(0, -1), // Don't include the item itself in parentPath
        });
      }

      // If this item has children, search through them too
      if (item.children && Array.isArray(item.children)) {
        const childResults = findStateRecursive(
          item.children,
          targetState,
          currentPath
        );
        results = [...results, ...childResults];
      }
    }

    return results;
  };

  const handleSearch = () => {
    if (!stateToFind.trim()) {
      setResults([]);
      setNotFound(false);
      return;
    }

    const foundItems = findStateRecursive(modelData, stateToFind);
    setResults(foundItems);
    setNotFound(foundItems.length === 0);
  };

  useEffect(() => {
    if (results.length > 0) {
      // Collect all states that need to be expanded - both results and their parent paths
      const nodesToExpand = results.reduce((acc, result) => {
        // Add the found item's state
        acc[result.state] = true;

        // Add all parent states from the path
        if (result.parentPath && Array.isArray(result.parentPath)) {
          result.parentPath.forEach((parentState) => {
            acc[parentState] = true;
          });
        }

        return acc;
      }, {});

      setExpandedNodes(nodesToExpand);
    }
  }, [results, setExpandedNodes]);

  const { apptheme } = useAppTheme();

  return (
    <SidebarSearchContainer>
      <CustomInputBox
        value={stateToFind}
        onChange={setStateToFind}
        onKeyDown={handleSearch}
      />
      <Button
        onClick={() => handleSearch()}
      >
        <SearchIcon />
      </Button>
    </SidebarSearchContainer>
  );
};
